/* Iter 275 — Tenant-aware brand-name resolver usable from non-React
 * code (lib utilities, Notification API callers, zip-download helpers).
 *
 * Reads from the same `hv_branding_by_host` localStorage cache that
 * TenantBrandingContext writes to per-host on every branding hydrate,
 * so it stays in lockstep with the React side without needing a hook.
 *
 * Falls back to "Rogue" — the public Geminii brand — when nothing is
 * cached yet (first cold load). Never returns "HidroVerse" verbatim
 * unless the running tenant truly is HidroVerse and has set their
 * `branding.app_name`.
 */

const CACHE_KEY = "hv_branding_by_host";

function _readCached() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const all = JSON.parse(raw);
    const host = (window.location.hostname || "").toLowerCase();
    return (all && typeof all === "object" && all[host]) || null;
  } catch {
    return null;
  }
}

/** Returns the current tenant's app brand name (e.g. "SalesFlow",
 *  "Rogue"). For filenames use `brandSlug()` which is filesystem-safe. */
export function brandName() {
  const cached = _readCached();
  return cached?.branding?.app_name || "Rogue";
}

/** Filesystem-safe slug for the current tenant's brand name. */
export function brandSlug() {
  return brandName().replace(/[^A-Za-z0-9]+/g, "");
}
